import React from "react";
import { TDetailedEmailForm } from "../../../../../domain/codecs/form/TriageForm";
import { CRMCaseQuickSummaryCard } from "../CRMCaseQuickSummaryCard/CRMCaseQuickSummaryCard";
import { CRMEmptyPlaceholder } from "../../Simple/CRMEmptyPlaceholder/CRMEmptyPlaceholder";
import { Padding } from "../../BuildingBlocks/Padding";
import { CRMSpacing } from "../../../models/CRMSpacing";

type TCRMInboxCaseSummaryBlockProps = {
    openEmail: TDetailedEmailForm | null;
};

export const CRMInboxCaseSummaryBlock = (props: TCRMInboxCaseSummaryBlockProps): JSX.Element => {
    if (props.openEmail === null) {
        return (
            <Padding spacing={CRMSpacing.X_LARGE}>
                <CRMEmptyPlaceholder iconName="email" iconSize="140px">
                    Select an email to see its case summary.
                </CRMEmptyPlaceholder>
            </Padding>
        );
    }

    const caseId = props.openEmail.children.email.currently_assigned_case_id;

    if (caseId === null) {
        return (
            <Padding spacing={CRMSpacing.X_LARGE}>
                <CRMEmptyPlaceholder iconName="robot" iconSize="140px">
                    No case assigned to this email yet.
                </CRMEmptyPlaceholder>
            </Padding>
        );
    }

    return (
        <Padding spacing={CRMSpacing.MEDIUM}>
            <CRMCaseQuickSummaryCard caseId={caseId} />
        </Padding>
    );
};
